if (!customElements.get('addon-selector')) {
  class AddonSelector extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form.product-purchase-form');
      this.checkboxes = Array.prototype.slice.call(
        this.querySelectorAll('.addon-selector__checkbox')
      );
      this.errorEl = this.querySelector('.addon-selector__error');
      this.propertyInput = this.querySelector('[data-addon-property]');
      this.pairInput = this.querySelector('[data-addon-pair]');

      if (!this.form || !this.checkboxes.length) return;

      // Exclusión mutua: marcar una desmarca las demás. Click de nuevo sobre
      // la ya marcada la desmarca sola (comportamiento nativo del checkbox),
      // sin necesidad de una opción "sin personalización".
      this.boundChange = this.handleCheckboxChange.bind(this);
      this.checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', this.boundChange);
      });

      // Fase de captura: corre antes que el listener de submit nativo del tema
      // (theme.applyAjaxToProductForm), que está atado directo al form en fase de bubble.
      this.boundSubmit = this.handleSubmit.bind(this);
      document.addEventListener('submit', this.boundSubmit, true);
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.boundSubmit, true);
      this.checkboxes.forEach((checkbox) => {
        checkbox.removeEventListener('change', this.boundChange);
      });
    }

    handleCheckboxChange(evt) {
      if (!evt.target.checked) return;
      this.checkboxes.forEach((checkbox) => {
        if (checkbox !== evt.target) checkbox.checked = false;
      });
    }

    getSelectedOption() {
      var checkbox = this.checkboxes.find((c) => c.checked);
      if (!checkbox) return null;
      var optionEl = checkbox.closest('[data-addon-option]');
      if (!optionEl) return null;
      return {
        checkbox: checkbox,
        variantId: parseInt(optionEl.dataset.addonVariantId, 10),
        label: optionEl.dataset.addonLabel,
      };
    }

    clearError() {
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    showError(message) {
      this.errorEl.hidden = false;
      this.errorEl.textContent = message;
    }

    getProductJson() {
      var script = document.getElementById('ProductJson-' + this.form.dataset.productId);
      return script ? JSON.parse(script.textContent) : null;
    }

    getSelectedVariant(product) {
      var idInput = this.form.querySelector('[name="id"]');
      if (!idInput) return null;
      var variantId = parseInt(idInput.value, 10);
      return product.variants.find(function (variant) {
        return variant.id === variantId;
      });
    }

    buildParaText(product, variant) {
      var optionParts = [];
      (product.options || []).forEach(function (optionName, index) {
        var value = variant['option' + (index + 1)];
        if (value && value !== 'Default Title') {
          optionParts.push(optionName + ': ' + value);
        }
      });

      var skuPart = variant.sku ? ' (SKU: ' + variant.sku + ')' : '';
      var titlePart = this.dataset.productTitle;

      return optionParts.length
        ? titlePart + ' — ' + optionParts.join(', ') + skuPart
        : titlePart + skuPart;
    }

    handleSubmit(evt) {
      if (evt.target !== this.form) return;
      if (this.form.dataset.addonHandled === 'true') return;

      var selectedOption = this.getSelectedOption();
      if (!selectedOption) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();
      this.clearError();

      var product = this.getProductJson();
      var variant = product ? this.getSelectedVariant(product) : null;
      if (!variant) {
        this.showError(this.dataset.errorGeneric);
        return;
      }

      var pair = 'a-' + Math.random().toString(36).slice(2, 8);
      var paraText = this.buildParaText(product, variant);

      fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: selectedOption.variantId,
            quantity: 1,
            properties: {
              'Para': paraText,
              '_addon_pair': pair
            }
          }]
        })
      }).
      then((response) => {
        // Cualquier 422 de /cart/add.js (stock real insuficiente, o una regla de
        // cantidad de Minmaxify u otra validación) se trata como "sin stock": es lo
        // que casi siempre significa en la práctica, y el texto exacto que devuelve
        // Shopify/Minmaxify no es estable ni previsible como para matchearlo por regex.
        if (!response.ok) throw new Error('addon-add-rejected');
        return response.json();
      }).
      then(() => {
        this.propertyInput.value = selectedOption.label;
        this.propertyInput.removeAttribute('disabled');
        this.pairInput.value = pair;
        this.pairInput.removeAttribute('disabled');
        this.form.dataset.addonHandled = 'true';

        // Dispatch síncrono: cuando requestSubmit() retorna, el listener nativo del
        // tema ya leyó el FormData. Ahí es seguro resetear el estado del addon.
        this.form.requestSubmit();

        delete this.form.dataset.addonHandled;
        this.propertyInput.value = '';
        this.propertyInput.setAttribute('disabled', '');
        this.pairInput.value = '';
        this.pairInput.setAttribute('disabled', '');
        selectedOption.checkbox.checked = false;
      }).
      catch((error) => {
        var isOutOfStock = error && error.message === 'addon-add-rejected';
        this.showError(isOutOfStock ? this.dataset.errorOutOfStock : this.dataset.errorGeneric);
        selectedOption.checkbox.checked = false;
      });
    }
  }

  customElements.define('addon-selector', AddonSelector);
}
